import {
  AuthenticatedUserFragment,
  MyselfFragment,
  CreatePathFlowInput
} from '#src/generated/graphql'

export enum RouteSelection {
  ONE_WAY,
  ROUND_TRIP
}

export interface ReactWaypointProps {
  currentPosition: string
}

export enum LandingPageBranding {
  DEAL,
  CURATED
}

export interface OnSubmitWithSlugInputs {
  sourceKey: string
  pathIntent?: Tracking.PathIntent
  prefillData?: CreatePathFlowInput
}

export interface OnSubmitInputs extends OnSubmitWithSlugInputs {
  slug: string
}
export interface LandingPageComponentProps {
  categorySlug: string
  content?: any
  onSubmit: ({ slug, sourceKey, prefillData }: OnSubmitInputs) => void
}

export interface SharedContentfulSchema {
  showFacebookMessengerAuth?: boolean
  facebookAppId?: string
  facebookPageId?: string
  brand?: LandingPageBranding
}

export type User = AuthenticatedUserFragment

export type Myself = MyselfFragment

export enum PathLayouts {
  BUBBA,
  BROOKS,
  DEFAULT,
  MODAL,
  WOODS,
  RORY
}
